module.exports = __webpack_public_path__ + "img/u5_musexingchen.81d92ef9.jpg";